import { $getQueryParams } from '@/utils';
import httpService from '@Utils/httpService';

//const dataApi = 'api/data';
const baseUrl = 'api/tasks';

export default {
  get(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '?' + qParams.toString(),
    });
  },
  getData(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '/data?' + qParams.toString(),
    });
  },
   getList(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '/data/List?' + qParams.toString(),
    });
  },
   getGantt(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '/data/Gantt?' + qParams.toString(),
    });
  },
  getGroups(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '/groups?' + qParams.toString(),
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  bulk(data) {
    return httpService.put({
      url: `${baseUrl}/Bulk`,
      data,
    });
  },
  move(data) {

    return httpService.put({
      url: `${baseUrl}/move/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  createMultiple(data) {
    return httpService.post({
      url: baseUrl + '/multiple',
      data,
    });
  },
  addOrUpdate(data, isNew) {
    if (isNew)
      return httpService.post({
        url: baseUrl,
        data,
      });
    else {
      return httpService.put({
        url: `${baseUrl}/${data.id}`,
        data,
      });
    }
  },
  getNextId() {
    return httpService.get({
      url: `${baseUrl}/next-Id`,
    });
  },
  duplicate(id) {
    return httpService.post({
      url: `${baseUrl}/duplicate/${id}`,
    });
  },

  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  deleteCollection(ids) {

    let data = { ids: ids };
    return httpService.post({
      url: baseUrl + '/DeleteCollection',
      data

    });
  },
  getCollection(ids) {
    return httpService.post({
      url: baseUrl + '/Get-Collection',
      data: ids
    });
  },
  /**
   * Batch tag-isolation aggregation for the Task Board.
   * Backend: POST /api/tasks/getIsolationByIds.
   * Returns one entry per requested taskId — tasks with no tags / no harvested
   * children come back with empty asset arrays so the caller can index by id
   * without dealing with misses.
   */
  getIsolationByIds(taskIds, assetId) {
    return httpService.post({
      url: baseUrl + '/getIsolationByIds',
      data: { taskIds, assetId: assetId || null }
    });
  },
  
  reorderGanttTask(data) {
    return httpService.put({
      url: baseUrl + '/reorderGanttTask',
      data,
    });
  },
  charts(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: `${baseUrl}/charts` + '?' + qParams.toString(),
    });
  },
   timeline(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: `${baseUrl}/charts-timeline` + '?' + qParams.toString(),
    });
  },
};
